export const EXTEND_EHW_PAGE_FORM = 'extendEHWPageForm';
